import { OPTION, SANS_SUITE } from '@/configuration/optionBlocage/optionBlocage';
import * as devisConf from '@/configuration/devisConf';
import * as produitConf from '@/configuration/produitConf';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import genererGuid from '@/services/general/genererGuid';
import {
  generationLignesCommandesMedia,
  generationLignesCommandesHorsMedia,
} from '@/services/devis/ajoutProduit/genererToutesLignesCommande';
import { getProduitDefault } from '@/services/general/genererReferenceProduit';
import { SURFACE_MAX } from '@/services/gestionPanneau/surfacePanneau';

function generationLigneCommandeRegroupement(produit, panneau, budget, ligneCommandeOld = null) {
  const ligneCommande = ligneCommandeOld ? ligneCommandeOld : genererLigneCommande();
  miseAJourArticle(ligneCommande);
  ligneCommande.quantiteDispo = panneau.pourcentageSurface / SURFACE_MAX;
  ligneCommande.affectation = [];
  ligneCommande.logo = null;
  ligneCommande.tauxTva = 0;
  ligneCommande.type = devisConf.REGROUPEMENT;
  ligneCommande.typeProduit = produitConf.CATEGORIE_UNITAIRE;
  ligneCommande.masqueLigne = false;

  // alimentation de la ligne avec des données du produit
  const produitLocation = getProduitDefault(panneau.categorie);
  ligneCommande.title = produitLocation && produitLocation.libelle
    ? [produit.reference, produitLocation.libelle].filter(Boolean).join(' - ')
    : produit.reference;
  ligneCommande.produit = produit;
  ligneCommande.produitId = produit.id;
  ligneCommande.libelle = produit.libelle;
  ligneCommande.fournisseur = produit.tiers;
  ligneCommande.fournisseurId = produit.tiersId;
  ligneCommande.etatObtenu = produit.panneauActif ? OPTION : SANS_SUITE;
  ligneCommande.etatSouhaite = produit.panneauActif ? OPTION : SANS_SUITE;

  // gestion des dates de début et de fin
  ligneCommande.dateDebut = budget.dateDebut;
  ligneCommande.dateFin = budget.dateFin;

  return ligneCommande;
}

function generationLigneCommandeRegroupementMedia(produit, panneau, budget, ligneCommandeOld, lignesCommandeOld) {
  const ligneCommande = generationLigneCommandeRegroupement(produit, panneau, budget, ligneCommandeOld);

  // identifiant unique de ligne pour maj ligne si ligneId = null
  ligneCommande.guid = budget.guid;

  // gestion des sous lignes
  ligneCommande.lignesCommande = generationLignesCommandesMedia(panneau, budget, lignesCommandeOld);
  return ligneCommande;
}

function generationLigneCommandeRegroupementHorsMedia(produit, panneau, budget, ligneCommandeOld, lignesCommandeOld) {
  const lignesCommandeHorsMedia = generationLignesCommandesHorsMedia(panneau, budget, lignesCommandeOld);
  if (lignesCommandeHorsMedia.length === 0) return null;

  const ligneCommande = generationLigneCommandeRegroupement(produit, panneau, budget, ligneCommandeOld);

  // identifiant unique de ligne pour maj ligne si ligneId = null
  ligneCommande.guid = budget.guidHorsMedia || genererGuid();

  // gestion des sous lignes
  ligneCommande.lignesCommande = lignesCommandeHorsMedia;
  return ligneCommande;
}

function getLignesCommandeOld(...lignesRegroupementOld) {
  return lignesRegroupementOld
    .filter(Boolean)
    .reduce((acc, ligneRegroupement) => acc.concat(ligneRegroupement.lignesCommande || []), []);
}

export default function ajoutLignesCommandeProduitFace({
  panneau, produit, ordre,
  budget, ligneCommandeOld, ligneCommandeHorsMediaOld,
}) {
  const lignesCommandeOld = getLignesCommandeOld(ligneCommandeOld, ligneCommandeHorsMediaOld);

  const ligneMedia = generationLigneCommandeRegroupementMedia(produit, panneau, budget, ligneCommandeOld, lignesCommandeOld);
  ajoutOrdre(ligneMedia, 0, ordre);
  const lignesCommande = [ligneMedia];

  const ligneHorsMedia = generationLigneCommandeRegroupementHorsMedia(produit, panneau, budget, ligneCommandeHorsMediaOld, lignesCommandeOld);
  if (ligneHorsMedia) {
    ligneHorsMedia.etatObtenu = ligneMedia.etatObtenu;
    ligneHorsMedia.etatSouhaite = ligneMedia.etatSouhaite;
    const ordreHorsMedia = ligneCommandeHorsMediaOld
      ? ligneCommandeHorsMediaOld.ordre
      : ordre + 100;
    ajoutOrdre(ligneHorsMedia, 0, ordreHorsMedia);
    lignesCommande.push(ligneHorsMedia);
  }

  return lignesCommande;
}
